<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 基础信息 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">个人信息</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <!-- 新增：身份证上传 section -->
              <div class="ant-row">
                <div class="ant-col">
                  <el-form-item prop="idCardObjectKeyFront">
                    <input
                      type="file"
                      class="file"
                      ref="idCardFrontPicFileName"
                      @change="idCardFrontPicImage($event)"
                      accept="image/*"
                    />
                    <div class="uploaded-box" v-if="idCardFrontPicUrl">
                      <img
                        src="../assets/images/remove.png"
                        alt=""
                        class="icon-del"
                        @click="clearFile('FRONT')"
                      />
                      <div class="image">
                        <img
                          class="image_tp"
                          :src="idCardFrontPicUrl"
                          alt="Image preview"
                        />
                      </div>
                    </div>
                    <div class="ant-spin-nested-loading">
                      <div class="ant-spin-container">
                        <div
                          class="upload-content idCard-back"
                          v-if="!idCardFrontPicUrl"
                        >
                          <svg
                            class="icon-svg icon-idcard-person"
                            viewBox="0 0 227.149123 115.021351"
                            version="1.1"
                          >
                            <title>身份证人像面</title>
                            <g
                              id="PC-实名认证"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="PC端认证-主题色替换"
                                transform="translate(-503.9649, -519.8771)"
                              >
                                <g
                                  id="身份证人像面"
                                  transform="translate(478, 497)"
                                >
                                  <polygon
                                    id="矩形备份-2"
                                    points="0 0 280 0 280 160 0 160"
                                  ></polygon>
                                  <path
                                    d="M234.673631,73.3673982 C242.442541,76.7243346 251.845876,82.1913452 252.900913,88.7133931 L253.114035,103.213371 C253.114035,110.023156 180.745614,110.023156 180.745614,103.213371 L181.033351,88.7133931 C182.184301,82.2872577 191.608933,76.7243346 199.377843,73.3673982 L213.189238,96.5782155 L214.81975,86.2196689 C213.668801,85.5482816 212.901501,84.3014196 212.901501,82.8627325 C212.901501,80.6567458 214.723838,78.8344089 216.929825,78.8344089 C219.135811,78.8344089 220.958148,80.6567458 220.958148,82.8627325 C220.958148,84.3014196 220.190848,85.5482816 219.039899,86.2196689 L220.766323,96.7700404 Z M228.727058,29.2539652 C237.74283,33.3782014 233.426769,47.9568965 233.426769,47.9568965 C235.249106,48.3405464 236.687793,50.4506207 236.687793,52.9443449 C236.687793,55.7258065 234.865456,58.0277057 232.659469,58.0277057 L232.371732,58.0277057 C230.933045,67.3312152 224.410997,74.4287378 216.738,74.4287378 C209.065002,74.4287378 202.638867,67.4271276 201.104267,58.0277057 C198.994193,57.9317933 197.267769,55.629894 197.267769,52.9443449 C197.267769,50.9301831 198.226893,49.1078462 199.66558,48.4364589 C199.66558,48.4364589 194.19857,32.5149891 205.516241,26.5684161 C205.516241,26.5684161 205.889053,26.4014613 206.540274,26.1385641 L206.860262,26.0106731 C211.663751,24.1097 227.748751,18.5741119 228.727058,29.2539652 Z M222.300923,34.6250635 C222.300923,34.6250635 214.4361,39.6125118 204.365291,39.1329495 L204.343645,39.1550433 C204.222884,39.2796079 203.613136,39.9254893 202.926604,40.9552864 L201.775655,47.7650716 L201.775655,48.9160212 L201.392005,48.9160212 C200.624705,48.9160212 199.857405,49.2996711 199.377843,49.9710584 C198.802368,50.7383581 198.418718,51.6974828 198.418718,52.8484324 C198.418718,54.9585067 199.66558,56.7808436 201.20018,56.8767561 L202.063392,56.9726686 L202.159304,57.8358808 C202.830692,62.1519419 204.653029,66.0843531 207.338578,68.9617271 C208.58544,70.3045017 210.024127,71.3595388 211.654639,72.1268386 C213.189238,72.8941383 214.915663,73.2777882 216.642087,73.2777882 C218.464424,73.2777882 220.094936,72.8941383 221.725448,72.1268386 C223.260047,71.4554513 224.698734,70.3045017 226.041509,68.9617271 C228.631146,66.1802655 230.549395,62.2478543 231.220782,57.8358808 L231.412607,56.8767561 L232.467644,56.9726686 L232.659469,56.9726686 C233.426769,56.9726686 234.098156,56.5890187 234.673631,55.9176314 C235.249106,55.1503317 235.632756,54.0952945 235.632756,52.9443449 C235.632756,51.8893077 235.249106,50.8342706 234.673631,50.0669709 C234.098156,49.3955836 233.426769,49.0119337 232.659469,49.0119337 L232.179907,49.0119337 L231.316695,49.2037586 L231.12487,49.2037586 C231.12487,49.2037586 231.013247,48.1585621 230.75966,46.6119756 L230.690267,46.1975022 C229.782096,40.883352 227.336328,30.7406085 222.300923,34.6250635 Z M58.6666667,128.029982 L227.912281,128.029982 C229.01685,128.029982 229.912281,128.925413 229.912281,130.029982 L229.912281,135.898403 C229.912281,137.002973 229.01685,137.898403 227.912281,137.898403 L58.6666667,137.898403 C57.5620972,137.898403 56.6666667,137.002973 56.6666667,135.898403 L56.6666667,130.029982 C56.6666667,128.925413 57.5620972,128.029982 58.6666667,128.029982 Z M27.9649123,128.029982 L46.9912281,128.029982 C48.0957976,128.029982 48.9912281,128.925413 48.9912281,130.029982 L48.9912281,135.898403 C48.9912281,137.002973 48.0957976,137.898403 46.9912281,137.898403 L27.9649123,137.898403 C26.8603428,137.898403 25.9649123,137.002973 25.9649123,135.898403 L25.9649123,130.029982 C25.9649123,128.925413 26.8603428,128.029982 27.9649123,128.029982 Z M27.9649123,35.9247185 L46.9912281,35.9247185 C48.0957976,35.9247185 48.9912281,36.820149 48.9912281,37.9247185 L48.9912281,44.8896308 C48.9912281,45.9942003 48.0957976,46.8896308 46.9912281,46.8896308 L27.9649123,46.8896308 C26.8603428,46.8896308 25.9649123,45.9942003 25.9649123,44.8896308 L25.9649123,37.9247185 C25.9649123,36.820149 26.8603428,35.9247185 27.9649123,35.9247185 Z M58.6666667,35.9247185 L99.6228071,35.9247185 C100.727377,35.9247185 101.622807,36.820149 101.622807,37.9247185 L101.622807,44.8896308 C101.622807,45.9942003 100.727377,46.8896308 99.6228071,46.8896308 L58.6666667,46.8896308 C57.5620972,46.8896308 56.6666667,45.9942003 56.6666667,44.8896308 L56.6666667,37.9247185 C56.6666667,36.820149 57.5620972,35.9247185 58.6666667,35.9247185 Z M27.9649123,66.6264729 L46.9912281,66.6264729 C48.0957976,66.6264729 48.9912281,67.5219034 48.9912281,68.6264729 L48.9912281,75.5913852 C48.9912281,76.6959547 48.0957976,77.5913852 46.9912281,77.5913852 L27.9649123,77.5913852 C26.8603428,77.5913852 25.9649123,76.6959547 25.9649123,75.5913852 L25.9649123,68.6264729 C25.9649123,67.5219034 26.8603428,66.6264729 27.9649123,66.6264729 Z M58.6666667,66.6264729 L128.131579,66.6264729 C129.236148,66.6264729 130.131579,67.5219034 130.131579,68.6264729 L130.131579,75.5913852 C130.131579,76.6959547 129.236148,77.5913852 128.131579,77.5913852 L58.6666667,77.5913852 C57.5620972,77.5913852 56.6666667,76.6959547 56.6666667,75.5913852 L56.6666667,68.6264729 C56.6666667,67.5219034 57.5620972,66.6264729 58.6666667,66.6264729 Z M27.9649123,97.3282273 L46.9912281,97.3282273 C48.0957976,97.3282273 48.9912281,98.2236578 48.9912281,99.3282273 L48.9912281,106.29314 C48.9912281,107.397709 48.0957976,108.29314 46.9912281,108.29314 L27.9649123,108.29314 C26.8603428,108.29314 25.9649123,107.397709 25.9649123,106.29314 L25.9649123,99.3282273 C25.9649123,98.2236578 26.8603428,97.3282273 27.9649123,97.3282273 Z M58.6666667,97.3282273 L128.131579,97.3282273 C129.236148,97.3282273 130.131579,98.2236578 130.131579,99.3282273 L130.131579,106.29314 C130.131579,107.397709 129.236148,108.29314 128.131579,108.29314 L58.6666667,108.29314 C57.5620972,108.29314 56.6666667,107.397709 56.6666667,106.29314 L56.6666667,99.3282273 C56.6666667,98.2236578 57.5620972,97.3282273 58.6666667,97.3282273 Z"
                                    id="形状结合"
                                    fill-opacity="0.12"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <svg
                            class="icon-upload"
                            viewBox="0 0 29.9021785 28"
                            version="1.1"
                          >
                            <title>上传icon</title>
                            <g
                              id="PC-实名认证"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="PC端认证-主题色替换"
                                transform="translate(-933.0978, -535)"
                              >
                                <g id="编组-5" transform="translate(900, 533)">
                                  <g id="上传icon" transform="translate(32, 0)">
                                    <rect
                                      id="矩形"
                                      x="0"
                                      y="0"
                                      width="32"
                                      height="32"
                                    ></rect>
                                    <path
                                      d="M2.51940568,27.2061566 C1.73428641,27.2061566 1.0978215,27.8315798 1.0978215,28.6030783 C1.0978215,29.3745769 1.73428641,30 2.51940568,30 L29.5784158,30 C30.3635351,30 31,29.3745769 31,28.6030783 C31,27.8315798 30.3635351,27.2061566 29.5784158,27.2061566 L2.51940568,27.2061566 Z M8.55716214,12.734048 L14.6273266,6.69934635 L14.6273266,21.7022852 C14.6273266,22.4737838 15.2637915,23.0992069 16.0489107,23.0992069 C16.83403,23.0992069 17.4704949,22.4737838 17.4704949,21.7022852 L17.4704949,6.69934635 L23.5406594,12.7200788 C24.0951304,13.2616983 24.990622,13.2616983 25.545093,12.7200788 C25.8069899,12.4796805 25.9556631,12.1432935 25.9556631,11.7911259 C25.9556631,11.4389582 25.8069899,11.1025712 25.545093,10.8621729 L17.015588,2.39682756 C16.4285158,1.86772415 15.5271473,1.86772415 14.9400751,2.39682756 L6.41057003,10.8621729 C6.14867322,11.1025712 6,11.4389582 6,11.7911259 C6,12.1432935 6.14867322,12.4796805 6.41057003,12.7200788 C6.67850769,13.0273316 7.06886002,13.2053254 7.48062481,13.208005 C7.8923896,13.2106846 8.28510674,13.0377867 8.55716214,12.734048 Z"
                                      id="形状"
                                      fill-opacity="0.8"
                                      fill="currentColor"
                                      fill-rule="nonzero"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="title">身份证人像面</div>
                          <div class="gray-font font12">点击上传</div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div class="ant-col">
                  <el-form-item prop="idCardObjectKeyBack">
                    <input
                      type="file"
                      class="file"
                      ref="idCardBackPicFileName"
                      @change="idCardBackPicImage($event)"
                      accept="image/*"
                    />
                    <div class="uploaded-box" v-if="idCardBackPicUrl">
                      <img
                        src="../assets/images/remove.png"
                        alt=""
                        class="icon-del"
                        @click="clearFile('BACK')"
                      />
                      <div class="image">
                        <img
                          class="image_tp"
                          :src="idCardBackPicUrl"
                          alt="Image preview"
                        />
                      </div>
                    </div>
                    <div class="ant-spin-container">
                      <div
                        class="upload-content idCard-back"
                        v-if="!idCardBackPicUrl"
                      >
                        <svg
                          class="icon-svg icon-idcard-emblem"
                          viewBox="0 0 227 110.459821"
                          version="1.1"
                        >
                          <title>身份证国徽面</title>
                          <g
                            id="PC-实名认证"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="PC端认证-主题色替换"
                              transform="translate(-834.5, -521.78)"
                            >
                              <g
                                id="身份证国徽面"
                                transform="translate(808, 497)"
                              >
                                <path
                                  d="M0,0 L280,0 L280,160 L0,160 Z"
                                  id="矩形备份-2"
                                ></path>
                                <path
                                  d="M103.491071,126.119286 L251.5,126.119286 C252.604569,126.119286 253.5,127.014716 253.5,128.119286 L253.5,133.239821 C253.5,134.344391 252.604569,135.239821 251.5,135.239821 L103.491071,135.239821 C102.386502,135.239821 101.491071,134.344391 101.491071,133.239821 L101.491071,128.119286 C101.491071,127.014716 102.386502,126.119286 103.491071,126.119286 Z M103.491071,102.81125 L251.5,102.81125 C252.604569,102.81125 253.5,103.706681 253.5,104.81125 L253.5,109.931786 C253.5,111.036355 252.604569,111.931786 251.5,111.931786 L103.491071,111.931786 C102.386502,111.931786 101.491071,111.036355 101.491071,109.931786 L101.491071,104.81125 C101.491071,103.706681 102.386502,102.81125 103.491071,102.81125 Z M108.558036,52.1416071 L247.446429,52.1416071 C248.550998,52.1416071 249.446429,53.0370376 249.446429,54.1416071 L249.446429,70.4094643 C249.446429,71.5140338 248.550998,72.4094643 247.446429,72.4094643 L108.558036,72.4094643 C107.453466,72.4094643 106.558036,71.5140338 106.558036,70.4094643 L106.558036,54.1416071 C106.558036,53.0370376 107.453466,52.1416071 108.558036,52.1416071 Z M119.705357,24.78 L150.160714,24.78 C151.265284,24.78 152.160714,25.6754305 152.160714,26.78 L152.160714,36.9675 C152.160714,38.0720695 151.265284,38.9675 150.160714,38.9675 L119.705357,38.9675 C118.600788,38.9675 117.705357,38.0720695 117.705357,36.9675 L117.705357,26.78 C117.705357,25.6754305 118.600788,24.78 119.705357,24.78 Z M163.28125,24.78 L193.736607,24.78 C194.841177,24.78 195.736607,25.6754305 195.736607,26.78 L195.736607,36.9675 C195.736607,38.0720695 194.841177,38.9675 193.736607,38.9675 L163.28125,38.9675 C162.176681,38.9675 161.28125,38.0720695 161.28125,36.9675 L161.28125,26.78 C161.28125,25.6754305 162.176681,24.78 163.28125,24.78 Z M206.857143,24.78 L237.3125,24.78 C238.417069,24.78 239.3125,25.6754305 239.3125,26.78 L239.3125,36.9675 C239.3125,38.0720695 238.417069,38.9675 237.3125,38.9675 L206.857143,38.9675 C205.752573,38.9675 204.857143,38.0720695 204.857143,36.9675 L204.857143,26.78 C204.857143,25.6754305 205.752573,24.78 206.857143,24.78 Z M53.8616071,24.78 C68.9730055,24.78 81.2232143,37.0302088 81.2232143,52.1416071 C81.2232143,67.2530055 68.9730055,79.5032143 53.8616071,79.5032143 C38.7502088,79.5032143 26.5,67.2530055 26.5,52.1416071 C26.5,37.0302088 38.7502088,24.78 53.8616071,24.78 Z M59.9272774,55.6616964 L47.7959369,55.6616964 L47.1102321,59.7146964 L38.6607143,59.7152679 L36.1272321,65.795625 L71.0892857,65.795625 L68.5558036,59.7152679 L60.6122321,59.7146964 L59.9272774,55.6616964 Z M49.5546875,45.5545536 L48.5867443,47.5158208 L46.4223574,47.8303246 L47.9885224,49.3569582 L47.618801,51.5125995 L49.5546875,50.4948437 L51.490574,51.5125995 L51.1208526,49.3569582 L52.6870176,47.8303246 L50.5226307,47.5158208 L49.5546875,45.5545536 Z M57.6618304,45.5545536 L56.6938871,47.5158208 L54.5295002,47.8303246 L56.0956653,49.3569582 L55.7259439,51.5125995 L57.6618304,50.4948437 L59.5977168,51.5125995 L59.2279954,49.3569582 L60.7941605,47.8303246 L58.6297736,47.5158208 L57.6618304,45.5545536 Z M43.4743304,39.9808929 L42.5063871,41.9421601 L40.3420002,42.2566639 L41.9081653,43.7832975 L41.5384439,45.9389388 L43.4743304,44.921183 L45.4102168,45.9389388 L45.0404954,43.7832975 L46.6066605,42.2566639 L44.4422736,41.9421601 L43.4743304,39.9808929 Z M63.7421875,39.9808929 L62.7742443,41.9421601 L60.6098574,42.2566639 L62.1760224,43.7832975 L61.806301,45.9389388 L63.7421875,44.921183 L65.678074,45.9389388 L65.3083526,43.7832975 L66.8745176,42.2566639 L64.7101307,41.9421601 L63.7421875,39.9808929 Z M53.6082589,34.9139286 L52.1935727,37.780396 L49.030238,38.2400555 L51.3192485,40.4712892 L50.7788864,43.6218418 L53.6082589,42.1343527 L56.4376315,43.6218418 L55.8972694,40.4712892 L58.1862799,38.2400555 L55.0229452,37.780396 L53.6082589,34.9139286 Z"
                                  id="形状结合"
                                  fill-opacity="0.12"
                                  fill="currentColor"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                        <svg
                          class="icon-upload"
                          viewBox="0 0 29.9021785 28"
                          version="1.1"
                        >
                          <title>上传icon</title>
                          <g
                            id="PC-实名认证"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="PC端认证-主题色替换"
                              transform="translate(-933.0978, -535)"
                            >
                              <g id="编组-5" transform="translate(900, 533)">
                                <g id="上传icon" transform="translate(32, 0)">
                                  <rect
                                    id="矩形"
                                    x="0"
                                    y="0"
                                    width="32"
                                    height="32"
                                  ></rect>
                                  <path
                                    d="M2.51940568,27.2061566 C1.73428641,27.2061566 1.0978215,27.8315798 1.0978215,28.6030783 C1.0978215,29.3745769 1.73428641,30 2.51940568,30 L29.5784158,30 C30.3635351,30 31,29.3745769 31,28.6030783 C31,27.8315798 30.3635351,27.2061566 29.5784158,27.2061566 L2.51940568,27.2061566 Z M8.55716214,12.734048 L14.6273266,6.69934635 L14.6273266,21.7022852 C14.6273266,22.4737838 15.2637915,23.0992069 16.0489107,23.0992069 C16.83403,23.0992069 17.4704949,22.4737838 17.4704949,21.7022852 L17.4704949,6.69934635 L23.5406594,12.7200788 C24.0951304,13.2616983 24.990622,13.2616983 25.545093,12.7200788 C25.8069899,12.4796805 25.9556631,12.1432935 25.9556631,11.7911259 C25.9556631,11.4389582 25.8069899,11.1025712 25.545093,10.8621729 L17.015588,2.39682756 C16.4285158,1.86772415 15.5271473,1.86772415 14.9400751,2.39682756 L6.41057003,10.8621729 C6.14867322,11.1025712 6,11.4389582 6,11.7911259 C6,12.1432935 6.14867322,12.4796805 6.41057003,12.7200788 C6.67850769,13.0273316 7.06886002,13.2053254 7.48062481,13.208005 C7.8923896,13.2106846 8.28510674,13.0377867 8.55716214,12.734048 Z"
                                    id="形状"
                                    fill-opacity="0.8"
                                    fill="currentColor"
                                    fill-rule="nonzero"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                        <div class="title">身份证国徽面</div>
                        <div class="gray-font font12">点击上传</div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <el-form-item label="身份证号" prop="idCardNumber">
                <el-input
                  v-model="form.idCardNumber"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <div class="ant-row">
                <div class="ant-col">
                  <el-form-item prop="disabledCardObjectKeyFront">
                    <input
                      type="file"
                      class="file-cj"
                      ref="disabledFrontPicFileName"
                      @change="disabledFrontPicImage($event)"
                      accept="image/*"
                    />
                    <div class="uploaded-box-cj" v-if="disabledFrontPicUrl">
                      <img
                        src="../assets/images/remove.png"
                        alt=""
                        class="icon-del"
                        @click="clearFile('DisabledFront')"
                      />
                      <div class="image">
                        <img
                          class="image_tp-cj"
                          :src="disabledFrontPicUrl"
                          alt="Image preview"
                        />
                      </div>
                    </div>
                    <div class="ant-spin-nested-loading">
                      <div class="ant-spin-container-cj">
                        <div
                          class="upload-content idCard-back"
                          v-if="!disabledFrontPicUrl"
                        >
                          <svg
                            class="icon-upload-cj"
                            viewBox="0 0 29.9021785 28"
                            version="1.1"
                          >
                            <title>上传icon</title>
                            <g
                              id="PC-实名认证"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="PC端认证-主题色替换"
                                transform="translate(-933.0978, -535)"
                              >
                                <g id="编组-5" transform="translate(900, 533)">
                                  <g id="上传icon" transform="translate(32, 0)">
                                    <rect
                                      id="矩形"
                                      x="0"
                                      y="0"
                                      width="32"
                                      height="32"
                                    ></rect>
                                    <path
                                      d="M2.51940568,27.2061566 C1.73428641,27.2061566 1.0978215,27.8315798 1.0978215,28.6030783 C1.0978215,29.3745769 1.73428641,30 2.51940568,30 L29.5784158,30 C30.3635351,30 31,29.3745769 31,28.6030783 C31,27.8315798 30.3635351,27.2061566 29.5784158,27.2061566 L2.51940568,27.2061566 Z M8.55716214,12.734048 L14.6273266,6.69934635 L14.6273266,21.7022852 C14.6273266,22.4737838 15.2637915,23.0992069 16.0489107,23.0992069 C16.83403,23.0992069 17.4704949,22.4737838 17.4704949,21.7022852 L17.4704949,6.69934635 L23.5406594,12.7200788 C24.0951304,13.2616983 24.990622,13.2616983 25.545093,12.7200788 C25.8069899,12.4796805 25.9556631,12.1432935 25.9556631,11.7911259 C25.9556631,11.4389582 25.8069899,11.1025712 25.545093,10.8621729 L17.015588,2.39682756 C16.4285158,1.86772415 15.5271473,1.86772415 14.9400751,2.39682756 L6.41057003,10.8621729 C6.14867322,11.1025712 6,11.4389582 6,11.7911259 C6,12.1432935 6.14867322,12.4796805 6.41057003,12.7200788 C6.67850769,13.0273316 7.06886002,13.2053254 7.48062481,13.208005 C7.8923896,13.2106846 8.28510674,13.0377867 8.55716214,12.734048 Z"
                                      id="形状"
                                      fill-opacity="0.8"
                                      fill="currentColor"
                                      fill-rule="nonzero"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="title">残疾人证内页一</div>
                          <div class="gray-font font12">点击上传</div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div class="ant-col">
                  <div class="examplediagram">
                    <img src="../assets/images/canjiz.png" alt="" />
                    <div class="text">示例图</div>
                  </div>
                </div>
              </div>
              <div class="ant-row">
                <div class="ant-col">
                  <el-form-item prop="disabledCardObjectKeyBack">
                    <input
                      type="file"
                      class="file-cj"
                      ref="disabledBackPicFileName"
                      @change="disabledBackPicImage($event)"
                      accept="image/*"
                    />
                    <div class="uploaded-box-cj" v-if="disabledBackPicUrl">
                      <img
                        src="../assets/images/remove.png"
                        alt=""
                        class="icon-del"
                        @click="clearFile('DisabledBack')"
                      />
                      <div class="image">
                        <img
                          class="image_tp-cj"
                          :src="disabledBackPicUrl"
                          alt="Image preview"
                        />
                      </div>
                    </div>
                    <div class="ant-spin-nested-loading">
                      <div class="ant-spin-container-cj">
                        <div
                          class="upload-content idCard-back"
                          v-if="!disabledBackPicUrl"
                        >
                          <svg
                            class="icon-upload-cj"
                            viewBox="0 0 29.9021785 28"
                            version="1.1"
                          >
                            <title>上传icon</title>
                            <g
                              id="PC-实名认证"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="PC端认证-主题色替换"
                                transform="translate(-933.0978, -535)"
                              >
                                <g id="编组-5" transform="translate(900, 533)">
                                  <g id="上传icon" transform="translate(32, 0)">
                                    <rect
                                      id="矩形"
                                      x="0"
                                      y="0"
                                      width="32"
                                      height="32"
                                    ></rect>
                                    <path
                                      d="M2.51940568,27.2061566 C1.73428641,27.2061566 1.0978215,27.8315798 1.0978215,28.6030783 C1.0978215,29.3745769 1.73428641,30 2.51940568,30 L29.5784158,30 C30.3635351,30 31,29.3745769 31,28.6030783 C31,27.8315798 30.3635351,27.2061566 29.5784158,27.2061566 L2.51940568,27.2061566 Z M8.55716214,12.734048 L14.6273266,6.69934635 L14.6273266,21.7022852 C14.6273266,22.4737838 15.2637915,23.0992069 16.0489107,23.0992069 C16.83403,23.0992069 17.4704949,22.4737838 17.4704949,21.7022852 L17.4704949,6.69934635 L23.5406594,12.7200788 C24.0951304,13.2616983 24.990622,13.2616983 25.545093,12.7200788 C25.8069899,12.4796805 25.9556631,12.1432935 25.9556631,11.7911259 C25.9556631,11.4389582 25.8069899,11.1025712 25.545093,10.8621729 L17.015588,2.39682756 C16.4285158,1.86772415 15.5271473,1.86772415 14.9400751,2.39682756 L6.41057003,10.8621729 C6.14867322,11.1025712 6,11.4389582 6,11.7911259 C6,12.1432935 6.14867322,12.4796805 6.41057003,12.7200788 C6.67850769,13.0273316 7.06886002,13.2053254 7.48062481,13.208005 C7.8923896,13.2106846 8.28510674,13.0377867 8.55716214,12.734048 Z"
                                      id="形状"
                                      fill-opacity="0.8"
                                      fill="currentColor"
                                      fill-rule="nonzero"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="title">残疾人证内页二</div>
                          <div class="gray-font font12">点击上传</div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div class="ant-col">
                  <div class="examplediagram">
                    <img src="../assets/images/canjif.png" alt="" />
                    <div class="text">示例图</div>
                  </div>
                </div>
              </div>
              <el-form-item label="残疾人证号" prop="disabledCardNumber">
                <el-input
                  v-model="form.disabledCardNumber"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="残疾证发证地"
                prop="disabledCardIssuePlaceAreaCode"
              >
                <el-cascader
                  ref="disabledCardIssuePlace"
                  style="width: 100%"
                  filterable
                  clearable
                  :props="{
                    value: 'value',
                    label: 'label',
                    emitPath: false,
                  }"
                  :options="areaDataTree"
                  v-model="form.disabledCardIssuePlaceAreaCode"
                  @change="issuePlaceChoose"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="残疾类型" prop="disabledType">
                <el-select
                  v-model="form.disabledType"
                  placeholder="请选择残疾类型"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in disabledTypeOptions"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="残疾等级" prop="disabledLevel">
                <el-select
                  v-model="form.disabledLevel"
                  placeholder="请选择残疾等级"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in disabledLevelOptions"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" prop="realName">
                <el-input
                  v-model="form.realName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="gender">
                <el-select
                  v-model="form.gender"
                  placeholder="请选择性别"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in sex"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="联系方式" prop="phoneNumber">
                <el-input
                  v-model="form.phoneNumber"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="emailAddress">
                <el-input
                  v-model="form.emailAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  clearable
                  v-model="form.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择出生年月"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="户籍地" prop="nativePlaceAreaCode">
                <el-cascader
                  ref="nativePlace"
                  style="width: 100%"
                  filterable
                  clearable
                  :props="{
                    value: 'value',
                    label: 'label',
                    emitPath: false,
                  }"
                  :options="areaDataTree"
                  v-model="form.nativePlaceAreaCode"
                  @change="nativePlaceChoose"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="学历" prop="educationLevel">
                <el-select
                  v-model="form.educationLevel"
                  placeholder="请选择学历"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in education"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="毕业时间" prop="graduteTime">
                <el-date-picker
                  clearable
                  v-model="form.graduteTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择毕业时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="工作年限" prop="workingTime">
                <el-select
                  v-model="form.workingTime"
                  placeholder="请选择学历"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in termArray"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="现居住地" prop="currentResidenceAreaCode">
                <el-cascader
                  ref="currentResidence"
                  style="width: 100%"
                  filterable
                  clearable
                  :props="{
                    value: 'value',
                    label: 'label',
                    emitPath: false,
                  }"
                  :options="areaDataTree"
                  v-model="form.currentResidenceAreaCode"
                  @change="addressChoose"
                ></el-cascader>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  personalInfo,
  personalInfoCommit,
  areaInfoList,
  getPreviewUrl,
} from "@/api/index";
import { Debounce, handleTree } from "@/helper/utilities.js";
import COS from "cos-js-sdk-v5";
export default {
  name: "resume-basic",
  data() {
    return {
      URL: "/prod-api",
      sex: ["男", "女"],
      education: [
        "博士",
        "硕士",
        "本科",
        "大专",
        "中专",
        "高中",
        "初中及以下",
        "其他",
      ],
      termArray: [
        "无工作经验",
        "1年以下工作经验",
        "1年-3年工作经验",
        "3年-5年工作经验",
        "5年-10年工作经验",
        "10年以上工作经验",
      ],
      areaDataTree: [], // 省市区三级联数据，纯汉字
      issuePlaceOptions: [],
      nativePlaceOptions: [],
      selectedOptions: [],
      disabledTypeOptions: [
        "视力残疾",
        "听力残疾",
        "言语残疾",
        "肢体残疾",
        "智力残疾",
        "精神残疾",
        "多重残疾",
      ],
      disabledLevelOptions: ["一级", "二级", "三级", "四级"],
      idCardFrontPicUrl: "", // 正面图片临时路径
      idCardBackPicUrl: "", // 反面图片临时路径
      disabledFrontPicUrl: "", // 残疾人证正面图片临时路径
      disabledBackPicUrl: "", // 残疾人证正面图片临时路径
      form: {
        idCardNumber: undefined,
        idCardObjectKeyFront: undefined,
        idCardObjectKeyBack: undefined,
        disabledCardNumber: undefined,
        disabledCardObjectKeyFront: undefined,
        disabledCardObjectKeyBack: undefined,
        disabledCardIssuePlace: undefined,
        disabledCardIssuePlaceAreaCode: undefined,
        disabledType: undefined,
        disabledLevel: undefined,
        realName: undefined,
        gender: undefined,
        phoneNumber: undefined,
        emailAddress: undefined,
        birthday: undefined,
        nativePlace: undefined,
        nativePlaceAreaCode: undefined,
        educationLevel: undefined,
        graduteTime: undefined,
        workingTime: undefined,
        currentResidence: undefined,
        currentResidenceAreaCode: undefined,
      },
      rules: {
        idCardObjectKeyFront: [
          { required: true, message: "身份证人像面不能为空", trigger: "blur" },
        ],
        idCardObjectKeyBack: [
          { required: true, message: "身份证国徽面不能为空", trigger: "blur" },
        ],
        idCardNumber: [
          { required: true, message: "身份证号不能为空", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
            message: "请输入有效的18位身份证号",
            trigger: "blur",
          },
        ],
        disabledCardNumber: [
          { required: true, message: "残疾人证号不能为空", trigger: "blur" },
          { validator: this.validateDisabilityPrefix, trigger: "blur" },
        ],
        disabledCardObjectKeyFront: [
          {
            required: true,
            message: "残疾人证正面照不能为空",
            trigger: "blur",
          },
        ],
        disabledCardObjectKeyBack: [
          {
            required: true,
            message: "残疾人证背面照不能为空",
            trigger: "blur",
          },
        ],
        disabledCardIssuePlaceAreaCode: [
          {
            required: true,
            message: "残疾证发证地不能为空",
            trigger: "change",
          },
        ],
        disabledType: [
          { required: true, message: "残疾类型不能为空", trigger: "change" },
        ],
        disabledLevel: [
          { required: true, message: "残疾等级不能为空", trigger: "change" },
        ],
        realName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
        ],
        gender: [
          { required: true, message: "性别不能为空", trigger: "change" },
        ],
        phoneNumber: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的联系方式",
            trigger: "blur",
          },
        ],
        emailAddress: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            pattern:
              /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        birthday: [
          { required: true, message: "出生日期不能为空", trigger: "blur" },
        ],
        nativePlaceAreaCode: [
          { required: true, message: "户籍地不能为空", trigger: "change" },
        ],
        educationLevel: [
          { required: true, message: "学历不能为空", trigger: "change" },
        ],
        graduteTime: [
          { required: true, message: "毕业时间不能为空", trigger: "blur" },
        ],
        workingTime: [
          { required: true, message: "工作年限不能为空", trigger: "change" },
        ],
        currentResidenceAreaCode: [
          { required: true, message: "现居住地不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getPersonalInfo();
    this.getAreaInfo();
  },
  methods: {
    getPersonalInfo() {
      personalInfo()
        .then(async (res) => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              this.form = res.data.reMiniProgramPerson;
              if (res.data.reMiniProgramPerson.idCardObjectKeyFront) {
                this.idCardFrontPicUrl = await this.PreviewUrl(
                  res.data.reMiniProgramPerson.idCardObjectKeyFront
                );
              }
              if (res.data.reMiniProgramPerson.idCardObjectKeyBack) {
                this.idCardBackPicUrl = await this.PreviewUrl(
                  res.data.reMiniProgramPerson.idCardObjectKeyBack
                );
              }
              if (res.data.reMiniProgramPerson.disabledCardObjectKeyFront) {
                this.disabledFrontPicUrl = await this.PreviewUrl(
                  res.data.reMiniProgramPerson.disabledCardObjectKeyFront
                );
              }
              if (res.data.reMiniProgramPerson.disabledCardObjectKeyBack) {
                this.disabledBackPicUrl = await this.PreviewUrl(
                  res.data.reMiniProgramPerson.disabledCardObjectKeyBack
                );
              }
            }
          }
        })
        .catch((err) => {});
    },

    //查找省市区id
    findRegionIds(names) {
      const [provinceName, cityName, districtName] = names;
      // 查找匹配的省份
      const province = this.options.find((p) => p.label === provinceName);

      // 查找匹配的城市
      const city = province.children.find((c) => c.label === cityName);

      // 查找匹配的区县
      const district = city.children.find((d) => d.label === districtName);

      return [province.value, city.value, district.value];
    },

    /**
     * 自定义验证：残疾人证号前18位必须与身份证号一致
     * @param {Object} rule - 验证规则对象
     * @param {string} value - 残疾人证号输入值
     * @param {Function} callback - 验证结果回调
     */
    validateDisabilityPrefix(rule, value, callback) {
      // 1. 检查残疾人证号是否为空
      if (!value) {
        callback(new Error("请输入残疾人证号"));
        return;
      }

      // 2. 检查残疾人证号长度是否≥18位
      if (value.length < 20) {
        callback(new Error("残疾人证号长度不足20位"));
        return;
      }

      // 3. 检查身份证号是否已填写且有效
      const idCard = this.form.idCardNumber;
      if (!idCard) {
        callback(new Error("请先填写有效的身份证号"));
        return;
      }

      // 4. 提取残疾人证号前18位，与身份证号比较
      const disabilityPrefix = value.slice(0, 18);
      if (disabilityPrefix !== idCard) {
        callback(new Error("残疾人证号的前18位必须与身份证号一致"));
        return;
      }

      // 5. 验证通过
      callback();
    },

    //获取照片
    PreviewUrl(profilePhoto) {
      return new Promise((resolve, reject) => {
        getPreviewUrl(profilePhoto).then((response) => {
          if (response.code == 200) {
            resolve(response.msg);
          }
        });
      });
    },

    //获取地区
    getAreaInfo() {
      areaInfoList().then((res) => {
        let list = handleTree(res.data, "areaId", "parentId");
        this.areaDataTree = this.changeAreaInfoListFiled(list);
      });
    },

    changeAreaInfoListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach((t) => {
          let newItem = {
            label: t.areaName,
            value: t.areaCode,
            parentId: t.parentId,
            areaCode: t.areaCode,
            children: t.children,
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeAreaInfoListFiled(t.children);
          }
        });
      }
      return newList;
    },

    //残疾证发证地
    issuePlaceChoose(value) {
      // 获取组件实例
      const cascader = this.$refs.disabledCardIssuePlace;
      // 获取所有选中的节点对象（包含完整信息）
      const selectedNodes = cascader.getCheckedNodes();
      // 提取关键信息（可选）
      const result = selectedNodes.map((node) => ({
        label: node.label,
        value: node.value,
        // 可以添加其他需要的属性
        pathLabels: node.pathLabels, // 完整路径的标签数组
      }));
      console.log(result);
      if (value.length > 0) {
        if (result[0].pathLabels.length > 2) {
          this.form.disabledCardIssuePlace =
            result[0].pathLabels[0] +
            "-" +
            result[0].pathLabels[1] +
            "-" +
            result[0].pathLabels[2];
        } else {
          this.form.disabledCardIssuePlace =
            result[0].pathLabels[0] + "-" + result[0].pathLabels[1];
        }
        this.issuePlaceOptions = value;
      } else {
        this.form.disabledCardIssuePlace = "";
      }
    },

    //户籍地
    nativePlaceChoose(value) {
      // 获取组件实例
      const cascader = this.$refs.nativePlace;
      // 获取所有选中的节点对象（包含完整信息）
      const selectedNodes = cascader.getCheckedNodes();
      // 提取关键信息（可选）
      const result = selectedNodes.map((node) => ({
        label: node.label,
        value: node.value,
        // 可以添加其他需要的属性
        pathLabels: node.pathLabels, // 完整路径的标签数组
      }));
      if (value.length > 0) {
        if (result[0].pathLabels.length > 2) {
          this.form.nativePlace =
            result[0].pathLabels[0] +
            "-" +
            result[0].pathLabels[1] +
            "-" +
            result[0].pathLabels[2];
        } else {
          this.form.nativePlace =
            result[0].pathLabels[0] + "-" + result[0].pathLabels[1];
        }
        this.nativePlaceOptions = value;
      } else {
        this.form.nativePlace = "";
      }
    },

    //现居住地
    addressChoose(value) {
      // 获取组件实例
      const cascader = this.$refs.currentResidence;
      // 获取所有选中的节点对象（包含完整信息）
      const selectedNodes = cascader.getCheckedNodes();
      // 提取关键信息（可选）
      const result = selectedNodes.map((node) => ({
        label: node.label,
        value: node.value,
        // 可以添加其他需要的属性
        pathLabels: node.pathLabels, // 完整路径的标签数组
      }));
      if (value.length > 0) {
        if (result[0].pathLabels.length > 2) {
          this.form.currentResidence =
            result[0].pathLabels[0] +
            "-" +
            result[0].pathLabels[1] +
            "-" +
            result[0].pathLabels[2];
        } else {
          this.form.currentResidence =
            result[0].pathLabels[0] + "-" + result[0].pathLabels[1];
        }
        this.selectedOptions = value;
      } else {
        this.form.currentResidence = "";
      }
    },

    //清除图片
    clearFile(type) {
      let _this = this;
      if (type === "FRONT") {
        _this.idCardFrontPicUrl = "";
        _this.form.idCardObjectKeyFront = "";
        _this.$refs.idCardFrontPicFileName.value = null;
      } else if (type === "BACK") {
        _this.idCardBackPicUrl = "";
        _this.form.idCardObjectKeyBack = "";
        _this.$refs.idCardBackPicFileName.value = null;
      } else if (type === "DisabledFront") {
        _this.disabledFrontPicUrl = "";
        _this.form.disabledCardObjectKeyFront = "";
        _this.$refs.disabledFrontPicFileName.value = null;
      } else if (type === "DisabledBack") {
        _this.disabledBackPicUrl = "";
        _this.form.disabledCardObjectKeyBack = "";
        _this.$refs.disabledBackPicFileName.value = null;
      }
    },

    //uuid
    generateUUID() {
      var d = new Date().getTime(); //Timestamp
      var d2 =
        (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = Math.random() * 16; //random number between 0 and 16
          if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },

    //身份证人像面
    idCardFrontPicImage(event) {
      let uuid = this.generateUUID();
      const input = event.target;
      let types = input.files[0].name.split(".")[1];
      let objectKey = `湖北省残疾人求职招聘信息平台/身份证/正面/${uuid}.${types}`;
      if (input.files && input.files[0]) {
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 10) {
          this.uploads(files, objectKey, URL.createObjectURL(files), "FRONT");
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过10M！",
          });
        }
      }
    },

    //身份证国徽面
    idCardBackPicImage(event) {
      let uuid = this.generateUUID();
      const input = event.target;
      let types = input.files[0].name.split(".")[1];
      let objectKey = `湖北省残疾人求职招聘信息平台/身份证/背面/${uuid}.${types}`;
      if (input.files && input.files[0]) {
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 10) {
          this.uploads(files, objectKey, URL.createObjectURL(files), "BACK");
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过10M！",
          });
        }
      }
    },

    //残疾人证内页一
    disabledFrontPicImage(event) {
      let uuid = this.generateUUID();
      const input = event.target;
      let types = input.files[0].name.split(".")[1];
      let objectKey = `湖北省残疾人求职招聘信息平台/残疾人证内页一/${uuid}.${types}`;
      if (input.files && input.files[0]) {
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 10) {
          this.uploads(
            files,
            objectKey,
            URL.createObjectURL(files),
            "DisabledFront"
          );
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过10M！",
          });
        }
      }
    },

    //残疾人证内页二
    disabledBackPicImage(event) {
      let uuid = this.generateUUID();
      const input = event.target;
      let types = input.files[0].name.split(".")[1];
      let objectKey = `湖北省残疾人求职招聘信息平台/残疾人证内页二/${uuid}.${types}`;
      if (input.files && input.files[0]) {
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 10) {
          this.uploads(
            files,
            objectKey,
            URL.createObjectURL(files),
            "DisabledBack"
          );
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过10M！",
          });
        }
      }
    },

    //loading
    showLoading() {
      this.load = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    //上传
    async uploads(files, objectKey, imageUrl, type) {
      let _this = this;
      _this.showLoading();
      try {
        // 初始化实例
        const cos = new COS({
          // getAuthorization 必选参数
          getAuthorization: function (options, callback) {
            const url = _this.URL + "/api/miniProgram/getCosAuth";
            const xhr = new XMLHttpRequest();
            xhr.open("get", url, true);
            xhr.onload = function (e) {
              let data = JSON.parse(xhr.response).data;
              let timestamp = Math.floor(data.startTime / 1000);
              callback({
                TmpSecretId: data.tmpSecretId,
                TmpSecretKey: data.tmpSecretKey,
                SecurityToken: data.sessionToken,
                StartTime: timestamp, // 时间戳，单位秒，如：1580000000
                ExpiredTime: timestamp + 60, // 时间戳，单位秒，如：1580000000
              });
            };
            xhr.send();
          },
        });

        // 上传图片到COS
        await _this.uploadImageToCOS(cos, files, objectKey);

        if (type === "FRONT" || type === "BACK") {
          // 调用OCR识别
          const ocrResult = await _this.performOCR(cos, objectKey, type);
          if (type === "FRONT") {
            _this.idCardFrontPicUrl = imageUrl;
            _this.form.idCardNumber = ocrResult.IdInfo.IdNum;
            _this.form.realName = ocrResult.IdInfo.Name;
            _this.form.gender = ocrResult.IdInfo.Sex;
            _this.form.idCardObjectKeyFront = objectKey;
          } else {
            _this.idCardBackPicUrl = imageUrl;
            _this.form.idCardObjectKeyBack = objectKey;
          }
        } else if (type === "DisabledFront" || type === "DisabledBack") {
          if (type === "DisabledFront") {
            _this.disabledFrontPicUrl = imageUrl;
            _this.form.disabledCardObjectKeyFront = objectKey;
          } else {
            _this.disabledBackPicUrl = imageUrl;
            _this.form.disabledCardObjectKeyBack = objectKey;
          }
        }

        _this.$message({
          type: "success",
          message: "上传图片成功!",
        });
      } catch (error) {
        console.error("OCR识别失败:", error);
        _this.$message.error("识别失败，请重试");
      } finally {
        _this.load.close();
      }
    },

    // 上传图片到COS
    uploadImageToCOS(cos, files, objectKey) {
      return new Promise((resolve, reject) => {
        cos.uploadFile(
          {
            Bucket: "zhaopin-1322091753", // 替换为您的存储桶名称
            Region: "ap-nanjing", // 替换为您的存储桶区域
            Key: objectKey /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
            Body: files, // 上传文件对象
            SliceSize:
              1024 *
              1024 *
              10 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) {
              console.log(JSON.stringify(progressData));
            },
          },
          function (err, data) {
            if (err) {
              reject(err);
            } else {
              resolve(data);
            }
          }
        );
      });
    },

    // 执行OCR识别
    performOCR(cos, objectKey, type) {
      return new Promise((resolve, reject) => {
        cos.request(
          {
            Bucket: "zhaopin-1322091753", // 替换为您的存储桶名称
            Region: "ap-nanjing", // 替换为您的存储桶区域
            Method: "GET",
            Key: objectKey,
            Query: {
              "ci-process": "IDCardOCR",
              CardSide: type,
              Config: JSON.stringify({
                CropIdCard: true,
                CropPortrait: true,
                CopyWarn: true,
                BorderCheckWarn: true,
                ReshootWarn: true,
                DetectPsWarn: true,
              }),
            },
          },
          function (err, data) {
            if (err) {
              reject(err);
            } else {
              resolve(data.Response);
            }
          }
        );
      });
    },

    submit: Debounce(function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          personalInfoCommit(this.form)
            .then((res) => {
              if (res.code == 200) {
                this.$router.go(-1);
                this.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "warning",
                });
              }
            })
            .catch((err) => {});
        }
      });
    }, 1000),
  },
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}

.ant-row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  min-width: 0;
  .ant-col {
    flex: 0 0 50%;
    position: relative;

    .file {
      width: 280px;
      height: 158px;
      position: absolute;
      cursor: pointer;
      opacity: 0;
      border-color: orange;
      z-index: 15;
      left: 0;
    }
    .file-cj {
      width: 280px;
      height: 158px;
      position: absolute;
      cursor: pointer;
      opacity: 0;
      border-color: orange;
      z-index: 15;
      left: 0;
    }

    .examplediagram {
      width: 280px;
      height: 158px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0.5;
      }
      .text {
        position: absolute;
        font-size: 30px;
        font-weight: 800;
        color: red;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
    }

    .uploaded-box {
      width: 280px;
      height: 158px;
      position: absolute;
      z-index: 10;
      .icon-del {
        cursor: pointer;
        height: 18px;
        -o-object-fit: contain;
        object-fit: contain;
        position: absolute;
        right: -9px;
        top: -9px;
        width: 18px;
        z-index: 99;
      }
      .image_tp {
        width: 280px;
        height: 158px;
      }
    }
    .uploaded-box-cj {
      width: 280px;
      height: 158px;
      position: absolute;
      z-index: 10;
      .icon-del {
        cursor: pointer;
        height: 18px;
        -o-object-fit: contain;
        object-fit: contain;
        position: absolute;
        right: -9px;
        top: -9px;
        width: 18px;
        z-index: 99;
      }
      .image_tp-cj {
        width: 280px;
        height: 158px;
      }
    }
    .ant-spin-container {
      width: 280px;
      height: 158px;
      border: 1px dashed #d9d9d9;
      border-radius: 2px;
      cursor: pointer;
    }

    .ant-spin-container-cj {
      width: 280px;
      height: 158px;
      border: 1px dashed #d9d9d9;
      border-radius: 2px;
      cursor: pointer;
    }

    .idCard-back {
      background-color: #fff;
      height: 100%;
      position: relative;
      width: 100%;
      .icon-svg {
        color: #d00;
        height: calc(100% - 44px);
        left: 22px;
        position: absolute;
        top: 22px;
        width: calc(100% - 44px);
      }
      .icon-upload-cj {
        color: #d00;
        font-size: 32px;
        width: 32px;
        height: 32px;
        margin-bottom: 10px;
        margin-top: 36px;
        margin-left: 124px;
      }

      .icon-upload {
        color: #d00;
        font-size: 32px;
        width: 32px;
        height: 32px;
        margin-bottom: 10px;
        margin-top: 36px;
        margin-left: 124px;
      }

      .title {
        text-align: center;
        line-height: 14px;
      }
      .gray-font {
        font-size: 12px;
        color: #7f7f7f;
        text-align: center;
      }
    }

    .ant-conter {
      margin-top: 20px;
      .ant-conter-title {
        font-size: 16px;
        font-weight: 800;
      }
      .ant-conter-text {
        font-size: 14px;
        color: #7f7f7f;
      }
    }
  }
}
</style>
